import { useState } from 'react';
import Button from './Button';
import Modal from './Modal';
import { Cluster, Box, WithIcon } from './layouts';
import InfoIcon from 'imagesUwKluis/svg/info.svg';
import { useTranslation } from 'react-i18next';

const InfoModal = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = () => setIsOpen(value => !value);
  const { t } = useTranslation();

  return (
    <>
      <WithIcon color={'primary'}>
        <InfoIcon
          height="20px"
          width="20px"
          css={{ marginLeft: '8px', cursor: 'pointer' }}
          onClick={toggleModal}
        />
      </WithIcon>
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModal}
        showProgressBar
        width="440px"
      >
        <Box fontScale="xl" fontWeight="bold">
          {title}
        </Box>
        <Box pt="m">{children}</Box>
        <Cluster mt="xl" display="flex" justifyContent="flex-end" hGap="m">
          <Button variant="primary" onClick={toggleModal}>
            {t('Sluiten')}
          </Button>
        </Cluster>
      </Modal>
    </>
  );
};

export default InfoModal;
